const Menu =[{
    id:1,
    image:"https://assets.myntassets.com/h_1440,q_100,w_1080/v1/assets/images/2187783/2021/11/9/de450532-9acd-4039-9e21-4f77569fb01c1636448588262-HERENOW-Women-Navy-Blue-Printed-Top-4911636448587796-1.jpg",
   
    name:"TOP",
    category:"Women",
    price:525,
    descripation:"this is TOP",
    quantity:1,
    
   },
   {
       id:2,
       image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/13238794/2021/6/5/c44ab368-359b-4351-a4e2-38013be51e8b1622875534045-Anouk-Women-Tops-751622875533409-1.jpg",
       name:"Women top",
       category:"Women",
       price:425,
       descripation:"this is TOP",
       quantity:1,
   
   },
   {
       id:11,
       image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/15876338/2021/10/20/7e4ad8a7-044f-4ad3-82f0-b1f39c7170eb1634726013728LilPicksGirlsBeige1.jpg",
       name:"TOP",
       category:"Kids",
       price:225,
       descripation:"TOP for daily wear",
       quantity:1,
   
   },
   {
       id:6,
       image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/10341699/2022/8/25/c23fd879-a9b3-4515-a181-558523a71b9b1661423122029-LOCOMOTIVE-Men-Black--Grey-Slim-Fit-Checked-Casual-Shirt-342-1.jpg",
        name:"shirt",
       category:"Men",
       price:805,
       descripation:"this is black shirt",
       quantity:1,
   
   },
   { 
    id:3,
    image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/15301030/2021/9/14/b0acbbe3-4bf8-4dfd-849b-bfd147bebfbd1631611898015-Athena-Black--Yellow-Floral-printed-top-with-Sweetheart-neck-1.jpg",
    name:"Top",
    category:"Women",
    price:605,
    descripation:" floral print top",
    quantity:1,
   },
   {
    id:4,
    image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/17784334/2022/4/6/e90130a9-a667-48c4-baf0-0a702067398a1649256286179SeraBlackFloralPrintGeorgetteWrapTop1.jpg",
        name:"Top",
    category:"Women",
    price:665,
    descripation:" black floral print top",
    quantity:1,
   },
 {
       id:5,
       image:"https://assets.myntassets.com/h_1440,q_100,w_1080/v1/assets/images/4320912/2018/3/27/11522146123320-Ginger-by-Lifestyle-Women-Tops-8601522146123194-1.jpg",
       name:"Top",
       category:"Women",
       price:325,
       descripation:"lining top,daily wear",
       quantity:1,
   
   },
   {
       id:7,
       image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/8889611/2019/3/20/3eae8fb4-b7ca-4e01-80bf-d1e59ab1568d1553080254589-Roadster-Men-Black--White-Regular-Fit-Checked-Casual-Shirt-9-1.jpg",
       name:"Shirt",
       category:"Men",
       price:925,
       descripation:"Black and white shirt",
       quantity:1,
   
    },
    {
        id:8,
        image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/7488102/2019/8/22/8002a744-0dad-4dbb-9481-cf0090134c3b1566454086786-Dennis-Lingo-Men-Pink-Slim-Fit-Solid-Casual-Shirt-9891566454-1.jpg",
        name:"Shirt",
        category:"Men",
        price:1025,
        descripation:"pink shirt office wear",
        quantity:1,
    
     },
     {
        id:9,
        image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/1291760/2017/12/5/11512469309123-Highlander-Dark-Green-Slim-Fit-Casual-Shirt-5071512469308877-1.jpg",
        name:"Shirt",
        category:"Men",
        price:925,
        descripation:"causal wear shirt",
        quantity:1,
    
     },
   //   {
   //      id:10,
   //      image:"https://static.magicpin.com/storage/blog/images/myntra-online-shopping-for-mens_Formal_Shirt.jpg",
   //      name:"shirt",
   //      category:"Men",
   //      price:1225,
   //      descripation:"daily wear"
    
   //   },
     {
        id:12,
        image:"https://www.kalaniketan.com/media/catalog/product/cache/a21c1d38413de64f1250fbeb2309e062/K/N/KN_DL_GC_1662_PH.jpg",
        name:"Lahenga",
        category:"Kids",
        price:1225,
        descripation:"tradditional fastival wear",
        quantity:1,
        
    
     },
     {
        id:13,
        image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/18095442/2022/4/29/1d1b0fe5-6161-4d7e-9213-905c8d9159081651244868460pspeachesGirlsBlueLehengaCholi1.jpg",
        name:"Lahanga choli",
        category:"Kids",
        price:1005,
        descripation:"wedding wear",
        quantity:1,
    
     },
     {
        id:14,
        image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/22574804/2023/3/30/01842da6-84fd-49bf-b28f-c27e66b38ae01680119352928BitiyabyBhamaGirlsPeach-ColouredGold-TonedPrintedFoilPrintRe1.jpg",
        name:"Sharara",
        category:"Kids",
        price:925,
        descripation:"pink sharara ",
        quantity:1,
    
     },
     {
        id:15,
        image:"https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/23446806/2023/5/27/36fe4d57-e7ca-4171-be61-84a1631e55be1685194103853LehengaCholi1.jpg",
        name:"Lahanga",
        category:"Kids",
        price:905,
        descripation:"fastival wear",
        quantity:1,
    
     },
    

];
   export default Menu;